const GTM_CONTAINER_ID = process.env.REACT_APP_GTM_ID;

const isBrowser = typeof window !== "undefined";

const isProductionLive = () => {
  if (!isBrowser) return false;
  if (process.env.NODE_ENV !== "production") return false;
  if (!GTM_CONTAINER_ID) return false;

  const host = window.location.hostname;
  const localHosts = ["localhost", "127.0.0.1", "::1"];
  return !localHosts.includes(host);
};

export const initAnalytics = () => {
  if (!isProductionLive()) return;
  if (window.__arigloGtmInitialized) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  window.__arigloGtmInitialized = true;
};

export const trackPageView = (path) => {
  if (!isProductionLive()) return;
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: "page_view",
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};
